import BreadcrumbLinkModel from "../stores/shared/models/BreadcrumbLinkModel";
import RouteEnum from "./RouteEnum";

export const BreadcrumbMapping = new BreadcrumbLinkModel({
    code: "1",
    path: RouteEnum.HOME,
    label: "menu_lbl_home",
    sub: [],
});
